import { RotateCw } from "lucide-react";
import { clearMapCaches } from "../lib/mapHealth";

/* Shared overlay bits for every map: loading shimmer until first render, provider-switch hint, Reload button. */
export const MapChrome = ({ loading, switched, onReload, t, compact = false }) => {
  const reload = async () => { await clearMapCaches(); onReload(); };
  return (
    <>
      {loading && <div className="map-loading" data-testid="map-loading-shimmer" aria-live="polite"><span>{t?.mapLoading || "Loading map…"}</span></div>}
      {switched && <div className="map-switched" data-testid="map-switched-hint">{t?.mapSwitched || "Map provider switched for reliability"}</div>}
      <button type="button" className={`map-reload ${compact ? "map-reload-compact" : ""}`} onClick={reload} aria-label={t?.mapReload || "Reload map"} title={t?.mapReload || "Reload map"} data-testid="map-reload-button"><RotateCw size={14} />{!compact && <span>{t?.mapReload || "Reload map"}</span>}</button>
    </>
  );
};
